export type BlogPost = {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  // authorRole: string;
  // authorImage: string;
  date: string;
  image: string;
  featured: boolean;
  readTime: string;
  tags: string[];
  content: string;
};

export const blogPosts: BlogPost[] = [
  {
    id: "valentines-food-vendor-combos",
    title:
      "Valentine's Day Marketing Ideas for Food Vendors: Simple Combos That Actually Sell",
    category: "vendors",
    author: "Olawale Famoriyo",
    date: "February 2, 2026",
    readTime: "3 min read",
    image: "./assets/blog/pexels-roberto-cervantes.jpg",
    featured: false,
    tags: ["food business", "marketing", "vendors", "squaay"],
    excerpt:
      "Valentine's Day doesn't have to be stressful for food vendors. From ready-made love combos to breakfast-in-bed ideas, here are simple Valentine marketing ideas that help food, drinks, and pastry vendors sell more with less stress.",
    content: `
<div class="blog-content">

  <p>Hello faves</p>
  <p>We've been a little quiet, not because we forgot you, but because we've been busy building a better Squaay to make your life as a food vendor easier. This is our very first blog post. Cue small dance 💃🏽🎉</p>
  <p>This blog is simple on purpose. No grammar stress. No big big English. Just real, useful ideas to help you sell more food and smile more money this Valentine's Day.</p>
  <p>Valentine is coming, and many of you are already asking: <strong>“What special thing can I sell this year that people will actually buy?”</strong></p>
  <p>Relax. You're not alone. We've put together <strong>5 Valentine's Day ideas</strong> that work well for food, drinks, and pastry vendors. Please read till the end. <strong>Number 5 is mouth-watering 😋</strong></p>

  <h2>1. The “Don't Stress Me” Combo</h2>
  <p>Let's be honest. Most customers are lazy. And Valentine makes it worse. They don't want to think about:</p>
  <ul>
    <li>What food goes with what drink</li>
    <li>What dessert makes sense</li>
    <li>Whether it looks romantic or not</li>
  </ul>
  <p>Create a <strong>ready-made Valentine combo</strong> like:</p>
  <ul>
    <li>Jollof rice + grilled chicken + drink</li>
    <li>Small chops + wine + cupcake</li>
    <li>Burger + fries + milkshake</li>
  </ul>
  <p>Give it a cute name like:</p>
  <ul>
    <li>“Bae Starter Pack”</li>
    <li>“Love on a Plate”</li>
    <li>“No Stories Combo”</li>
  </ul>
  <p>When customers see it, their brain goes: “Oh thank God. I'll just buy this.” Easy win.</p>

  <h2>2. His & Hers Portions</h2>
  <p>Not everybody wants to eat from the same plate. Some couples love each other but still want equal food. Respect that</p>
  <p>Create:</p>
  <ul>
    <li><strong>His portion</strong> (bigger protein, bigger drink)</li>
    <li><strong>Her portion</strong> (cute size, still satisfying)</li>
  </ul>
  <p>Package it together and sell it as one Valentine deal. Works well for rice dishes, pasta, shawarma, and pastries. Bonus points if the packaging looks sweet and thoughtful.</p>

  <h2>3. Sweet Tooth Valentine Box</h2>
  <p>Some people don't want “food food.” They want <strong>sugar and happiness</strong>. If you sell pastries or desserts, this is your season.</p>
  <p>Create a box with:</p>
  <ul>
    <li>Cupcakes</li>
    <li>Doughnuts</li>
    <li>Brownies</li>
    <li>Cookies</li>
    <li>Small chocolate treats</li>
  </ul>
  <p>Name it something cute:</p>
  <ul>
    <li>“Sweet Like You Box”</li>
    <li>“Love & Sugar Box”</li>
    <li>“Valentine Dessert Box”</li>
  </ul>
  <p>People buy these for girlfriends, boyfriends, side baes (we won't judge), or even themselves (self-love matters!).</p>

  <h2>4. Budget-Friendly Love Deals</h2>
  <p>Not everybody has money like Dangote in February. Some customers just want to show love <strong>without crying at the bank app</strong>.</p>
  <p>Create a <strong>budget Valentine package</strong>:</p>
  <ul>
    <li>Small portion</li>
    <li>Simple drink</li>
    <li>Cute packaging</li>
    <li>Affordable price</li>
  </ul>
  <p>Label it clearly: <em>“Valentine Package Under ₦X”</em>. You'll be surprised how fast it sells.</p>

  <h2>5. Breakfast-in-Bed Valentine (Yes, this one)</h2>
  <p>This one is special. Many people want to surprise their partner <strong>early in the morning</strong>. Before work. Before stress. Before Lagos traffic.</p>
  <p>Think:</p>
  <ul>
    <li>Pancakes</li>
    <li>Waffles</li>
    <li>Tea or coffee</li>
    <li>Smoothies</li>
    <li>Croissants</li>
    <li>Parfait</li>
  </ul>
  <p>Package it as:</p>
  <ul>
    <li>“Breakfast in Bed”</li>
    <li>“Good Morning My Love”</li>
    <li>“Wake Up & Chop Love”</li>
  </ul>
  <p>This idea is <strong>gold</strong> if you can handle early orders. Customers love it. Partners love it. Everybody wins.</p>

  <h2>Extra Tip (Please Read This Part)</h2>
  <p>After curating your perfect Valentine package, you can:</p>
  <ul>
    <li>Create the product on the <strong>Squaay app</strong></li>
    <li>Share your unique product link with customers</li>
    <li>Let them order easily without plenty back and forth chat</li>
  </ul>

  <h3>Delivery Wahala 🚴🏽‍♂️</h3>
  <p>During Valentine:</p>
  <ul>
    <li>Riders are scarce</li>
    <li>Orders are plenty</li>
    <li>Your phone is ringing</li>
    <li>You're cooking, packaging, and replying messages at the same time</li>
  </ul>
  <p>The real problem is <strong>managing orders and deliveries together</strong>. That's where Squaay helps.</p>
  <ul>
    <li>You can <strong>book multiple deliveries at once</strong></li>
    <li>We assign riders for all your bookings</li>
    <li>You focus on cooking and serving customers</li>
    <li>We handle the delivery stress</li>
  </ul>
  <p>You do what you do best. We'll take care of getting the food to the door.</p>
  <p><strong>Check Squaay on the store and get ready for Valentine.</strong></p>
  <p>Love, money, and smooth deliveries to you this season</p>

</div>
  `,
  },
  {
    id: "why-ordering-lunch-feels-like-part-time-job",
    title: "Why Does Ordering Lunch Feel Like a Part-Time Job?",
    excerpt:
      "Ordering lunch shouldn't feel like a second job. From slow vendor responses to endless waiting, food delivery can be unnecessarily stressful. Here's how SQUAAY is making the virtual kitchen experience faster and smoother.",
    category: "food",
    author: "Oyindamola Fashina",
    date: "May 22, 2026",
    image:
      "./assets/blog/squaay-why-does-ordering-lunch-feel-like-a-part-time-job.png",
    featured: false,
    readTime: "2 min read",
    tags: [
      "food delivery",
      "virtual kitchens",
      "customer experience",
      "squaay",
    ],
    content: `
<div class="blog-content">
  <p>Let's be honest: by the time 1:00 PM hits in Lagos, you aren't just hungry; you are on a mission. You open your phone, ready to handle a basic human need, eating.</p>
  <p>But instead of a seamless transaction, you are suddenly thrown into a project management crisis.</p>
  <p>First, you have to decide what you want. Then you have to find a vendor who actually has it available. Then comes the inevitable back-and-forth: “Hello, do you have jollof?” “No, only fried rice is left.” By the time you finally click "order," you've spent 15 minutes of your precious break just navigating the logistics.</p>
  <p>Why does getting a plate of food feel like a secondary employment?</p>
  <h2>The Real Enemy: The Digital Wait Time</h2>
  <p>At SQUAAY, we did the math, and we noticed something frustrating. On a standard platform, the average user spends way too much time just waiting for a vendor to acknowledge their existence. You place an order, and then you sit there staring at a loading screen, wondering if the kitchen received it, if the chef is asleep, or if your lunch has entered a digital black hole.</p>
  <p>That "small" 5-minute gap where nothing happens? It's a mood killer. It's the gap where hunger turns into pure frustration. In 5 minutes, you could have replied to three emails, scrolled through TikTok, or, you know, actually been eating</p>
  <p>We believe that if a kitchen is virtual, the efficiency should be real.</p>

  <h2>Enter the No-Stress Zone</h2>
  <p>We didn't build SQUAAY to give you another app to babysit. The entire virtual kitchen experience is designed to cut out the "part-time job" feeling.</p>
  <p>When you order from the Yaba or Berger axis on our platform, we don't leave you guessing. We have optimized our vendor system to ensure that the bridge between you seeing the food and the kitchen prepping the food is practically instant.</p>
  <p>No endless loading screens, no "ghosting" from the vendor side, and no administrative stress just to get a plate of turkey and rice.</p>
  <p>You have enough work to do today. Ordering your lunch shouldn't be part of it.</p>
  <p>Step out of the office drama and into the virtual kitchen. Let's get you fed, fast.</p>
</div>
  `,
  },
  {
    id: "3-ways-to-hack-your-hunger",
    title: "3 Ways to Hack Your Hunger: From Saved Combos to 10-Second Orders",
    excerpt:
      "Beat the 4:00 PM crash with three hunger hacks: saved combos, future-self orders, and 10-second voice commands.",
    category: "food",
    author: "Oyindamola Fashina",
    date: "July 8, 2026",
    image: "./assets/blog/3-ways-to-hack-your-hunger.png",
    featured: false,
    readTime: "2 min read",
    tags: ["food delivery", "productivity", "voice orders", "squaay"],
    content: `
<div class="blog-content">
  <p>It is 4:00 PM, your energy is crashing, and your stomach is roaring. Instead of eating, you spend 20 minutes scrolling through menus, paralyzed by choices.</p>
  <p>Hunger causes decision fatigue, making complex app interfaces your worst enemy. You need a system</p>
  <p>Here are three ways to hack your hunger and get food faster.</p>

  <ol>
    <li><strong>Stick to "Saved Combos"</strong>: Build a go-to list of 2-3 meals you love from trusted spots. Tapping a pre-saved bundle cuts out the scrolling tax completely.</li>
    <li><strong>Order for your future self</strong>: Don't wait until you are starving. Order your lunch at 11:30 AM so it hits your desk exactly when hunger strikes, keeping your productivity seamless.</li>
    <li><strong>Switch to 10-Second Voice Orders</strong>: Typing addresses and searching items takes too long when you are busy. Squaay allows you to speak your order, bypass the screen, and get back to your day in under 10 seconds.</li>
  </ol>

  <h2>FAQ</h2>
  <ul>
  <li><strong>What is the fastest food delivery in Lagos?</strong> The fastest delivery relies on eliminating order friction. SQUAAY cuts order times to under 10 seconds using voice commands, hitting the kitchen instantly.</li>
  <li><strong>How can I get food delivered instantly when I'm busy?</strong> Use apps that support voice ordering and automatic checkout to place orders while multitasking.</li>
  <li><strong>Why does ordering food online take so long?</strong> It is usually delayed by decision fatigue, complex menus, and multi-step manual checkouts.</li>
  </ul>
  <p><strong>Ready to beat the 4:00 PM crash?</strong> Download <a href="https://www.squaay.com/download" target="_blank" rel="noopener noreferrer"><strong><u>SQUAAY</u></strong></a> on the App Store or Google Play today, lock in your favorite "Saved Combos," and get ready to experience the 10-second voice command revolution. Your voice is the only menu you need.</p>
</div>
  `,
  },
  {
    id: "future-of-food-is-voice-activated",
    title: "The Future of Food is Voice-Activated",
    excerpt:
      "Voice is replacing screens for food orders. Save your combos, speak your request, and let SQUAAY send your lunch to the kitchen in seconds.",
    category: "food",
    author: "Oyindamola Fashina",
    date: "July 13, 2026",
    image: "./assets/blog/the-future-of-food-is-voice-activated.png",
    featured: false,
    readTime: "2 min read",
    tags: ["voice tech", "food delivery", "accessibility", "squaay"],
    content: `
<div class="blog-content">
  <p>You send voice notes on WhatsApp instead of typing long paragraphs, and you ask your phone to set alarms when your hands are full.</p>
  <p>We are moving away from screens and moving toward our voices. So why are we still painstakingly tapping, scrolling, and typing just to get lunch?</p>
  <p>Ordering food online feels seamless until you break it down. You have to unlock your phone, open an app, search, scroll, customize (extra pepper, no onions, double protein), enter your address, and pay. If you are driving through Lagos traffic or handling a tight work deadline, that process is pure friction. And when you are hungry, friction is the enemy.</p>
  <p>Voice tech cuts out the screen entirely. Imagine you are exhausted after a long week. Instead of scrolling, you open SQUAAY and say: "Order my Asun Saved Combo."</p>
  <p>Because you've already saved your preferences, the app recognizes the command, pulls up your exact spicy Asun order, and sends it straight to the kitchen. No typing, no searching. Just a 3-second conversation.</p>

  <h2>Why Voice is the Ultimate Convenience</h2>
  <ul>
    <li><strong>True Multitasking:</strong> Order dinner while typing an email or getting dressed.</li>
    <li><strong>Zero Decision Fatigue:</strong> Combine voice commands with Saved Combos to eliminate daily food stress.</li>
    <li><strong>Accessibility:</strong> If you can speak, you can get fed.</li>
  </ul>

  <p>The keyboard had a good run, but it's time to retire the typing. Welcome to the future of food tech, where your voice is the only menu you need.</p>
  <p><strong>Ready to retire the keyboard?</strong> Download <a href="https://www.squaay.com/download" target="_blank" rel="noopener noreferrer"><strong><u>SQUAAY</u></strong></a> on the App Store or Google Play today, set up your first "Saved Combo," and get ready to talk to your food. <strong>Your voice is the only menu you need.</strong></p>
</div>
  `,
  },
  {
    id: "spend-less-time-ordering-more-time-eating",
    title: "Spend Less Time Ordering, More Time Eating",
    excerpt:
      "Manual food ordering steals time from your day. Simplify the process with automation and voice ordering so you can spend more time eating and less time navigating apps.",
    category: "food",
    author: "Oyindamola Fashina",
    date: "August 3, 2026",
    image: "./assets/blog/squaay-spend-less-time-ordering-more-time-eating.png",
    featured: false,
    readTime: "2 min read",
    tags: ["food delivery", "time saving", "voice orders", "squaay"],
    content: `
<div class="blog-content">
  <p>Think about how long it takes to order food manually when you are busy. It is not just the delivery driver's commute; it is the time you spend unlocking your phone, logging into an app, scrolling past restaurants you do not like, and tapping through checkout screens.</p>
  <p>That is a daily time tax you do not need to pay.</p>
  <p>Life moves fast, especially when you are balancing a career, family, and everything in between. Why should you waste a chunk of your day trying to figure out how to get lunch delivered? True soft life is about eliminating unnecessary micro-tasks that drain your time and energy.</p>
  <p>When you automate and simplify your routine tasks, you reclaim your day.</p>

  <p><strong>Ditch the Screen: </strong>You should not have to stop your workflow or pull over your car just to click through food options.</p>
  <p> <strong>Instant Gratification: </strong>Getting your order straight to the kitchen instantly means your food preparation starts immediately, cutting down total wait times.</p>
  <p>  <strong>Enjoy the Meal, Forget the Process: </strong>Technology should work for you, running smoothly in the background while you focus on eating and relaxing.</p>

  <p>Spending less time dealing with clunky app checkouts means spending more time enjoying your food and your breaks. Simplify your life, leverage your voice, and let technology handle the heavy lifting.</p>
  <p><strong>Ready to eliminate the time-tax?</strong> Download <a href="https://www.squaay.com/download" target="_blank" rel="noopener noreferrer"><strong><u>SQUAAY</u></strong></a> on the App Store or Google Play today, reclaim your lunch break, and let your voice do the heavy lifting. <strong>Your voice is the only menu you need.</strong></p>
</div>
  `,
  },
  {
    id: "say-hello-to-the-10-second-food-revolution",
    title: "Say Hello to the 10-Second Food Revolution",
    excerpt:
      "The days of typing, scrolling, and overthinking lunch are over. With SQUAAY, your saved combos and voice commands make ordering food faster than ever.",
    category: "food",
    author: "Oyindamola Fashina",
    date: "August 3, 2026",
    image: "./assets/blog/squaay-more-time-living.png",
    featured: false,
    readTime: "2 min read",
    tags: ["voice tech", "food delivery", "squaay"],
    content: `
<div class="blog-content">
  <p>Starting today, you can permanently retire the typing, the endless scrolling, and daily decision fatigue. SQUAAY is officially available on the App Store and Google Play.</p>
  <p>We didn't just build another directory app with a static list of restaurants. We built an ecosystem that actively listens to you. Moving forward, getting your food requires exactly two features:</p>

  <p><strong>The Saved Combo: </strong>Lock in your hyper-specific order preferences once—sides, extras, and all—and access it right from your main dashboard with one single tap.</p>
  <p><strong>Voice Command: </strong>Open the app, state your order out loud, and watch it head straight to the kitchen in under 10 seconds flat.</p>

  <p>Hunger shouldn't interrupt your hustle. Whether you are driving through intense traffic, stuck in back-to-back remote meetings, or just completely drained after a long day, you can now get food moving to your location without ever touching a keyboard. Technology should adapt to your life, not the other way around.</p>
  <p><strong>Ready to eliminate the app friction?</strong> Download <a href="https://www.squaay.com/download" target="_blank" rel="noopener noreferrer"><strong><u>SQUAAY</u></strong></a> on the App Store or Google Play today, set up your first "Saved Combo," and let your voice handle the rest. <strong>Your voice is the only menu you need.</strong></p>
</div>
  `,
  },
];

export const blogCategories = [
  "all",
  ...Array.from(new Set(blogPosts.map((post) => post.category))),
];

export const getBlogPostById = (id: string | undefined) =>
  blogPosts.find((post) => post.id === id);
